// extracted by mini-css-extract-plugin
module.exports = {"container":"BannerPromo_container__2bY64","textContainer":"BannerPromo_textContainer__ozzZ4","text":"BannerPromo_text___DjnM","button":"BannerPromo_button__e2O4R"};